(() => {
  const el = document.getElementById('reyra-analytics-config');
  if (!el || window.__reyraAnalyticsStarted || window.Shopify?.designMode) return;
  const config = JSON.parse(el.textContent);
  if (!config.enabled) return;
  window.__reyraAnalyticsStarted = true;
  const id = /^G-[A-Z0-9]+$/.test(config.measurementId) ? config.measurementId : '';
  const page = location.pathname;
  if (/^\/(account|checkout|checkouts|orders|search)(\/|$)/.test(page)) return;
  const safePath = (value) => {
    try {
      const u = new URL(value, location.origin);
      if (u.origin !== location.origin) return u.hostname;
      return /^\/(account|checkout|checkouts|orders|search)(\/|$)/.test(u.pathname) ? '/private' : u.pathname;
    } catch { return ''; }
  };
  let allowed = false, initialized = false, started = null, elapsed = 0;
  const base = { page_path: page, page_type: config.pageType, product_id: config.productId || '', product_name: config.productName || '' };
  const emit = (name, data = {}) => {
    if (!allowed) return;
    const payload = { ...base, ...data };
    try { window.Shopify?.analytics?.publish(name, payload); } catch {}
    if (id && typeof window.gtag === 'function') window.gtag('event', name, { ...payload, send_to: id, transport_type: 'beacon' });
  };
  const tick = () => {
    const now = performance.now();
    if (started !== null) elapsed += now - started;
    started = allowed && document.visibilityState === 'visible' && document.hasFocus() ? now : null;
  };
  const flush = () => {
    tick();
    if (elapsed >= 1000 && allowed) {
      emit('reyra_page_engagement', { active_seconds: Math.round(elapsed / 1000), engagement_time_msec: Math.round(elapsed) });
      elapsed = 0;
    }
  };
  const sync = () => {
    tick();
    allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    if (!allowed) {
      elapsed = 0; started = null;
      if (id && initialized) window.gtag('consent', 'update', { analytics_storage: 'denied' });
      return;
    }
    if (id && !initialized) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function() { window.dataLayer.push(arguments); };
      window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      window.gtag('js', new Date());
      window.gtag('config', id, { send_page_view: false, page_location: location.origin + page, page_referrer: document.referrer ? safePath(document.referrer) : '', allow_google_signals: false, allow_ad_personalization_signals: false });
      const script = document.createElement('script');
      script.async = true; script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id); document.head.appendChild(script);
    }
    if (id) window.gtag('consent', 'update', { analytics_storage: 'granted' });
    if (!initialized) {
      emit('reyra_page_view', { previous_page: safePath(document.referrer) });
      if (config.productId) emit('reyra_product_view');
      initialized = true;
    }
    tick();
  };
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('a,button,summary,[role="button"]') : null;
    if (!target || !allowed || target.closest('form[action*="contact"],form[action*="account"]')) return;
    const section = target.closest('[id^="shopify-section-"]');
    const area = target.closest('header,header-drawer') ? 'header_menu' : target.closest('footer') ? 'footer' : section?.id || 'page';
    const url = target.matches('a') ? safePath(target.href) : '';
    const label = target.getAttribute('data-analytics-label') || target.getAttribute('aria-label') || target.textContent.trim().replace(/\s+/g, ' ');
    emit('reyra_click', { element_label: label.slice(0, 80), element_type: target.tagName.toLowerCase(), section_name: area, destination_path: url });
    if (url.includes('/products/')) emit('reyra_product_click', { destination_path: url, section_name: area });
    if (target.matches('summary')) emit('reyra_detail_toggle', { element_label: label.slice(0, 80), action: target.parentElement.open ? 'close' : 'open', section_name: area });
  }, true);
  let depth = 0;
  window.addEventListener('scroll', () => {
    if (!allowed) return;
    const max = document.documentElement.scrollHeight - innerHeight;
    if (max <= 0) return;
    const value = Math.min(100, Math.floor(scrollY / max * 100));
    for (const point of [25, 50, 75, 90]) if (value >= point && depth < point) { emit('reyra_scroll_depth', { percent_scrolled: point }); depth = point; }
  }, { passive: true });
  document.addEventListener('visibilitychange', flush);
  window.addEventListener('blur', flush);
  window.addEventListener('focus', tick);
  window.addEventListener('pagehide', flush);
  window.addEventListener('pageshow', tick);
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('trackingConsentAccepted', sync);
  setInterval(flush, 15000);
  if (window.Shopify?.customerPrivacy) sync();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) sync(); });
})();